import DataService from "@/services/DataService";

export default {
  sendMail(data) {
    return DataService.apiClient.post("/mail/send", data);
  }
};
